import ZkDialog from './src/dialog'

/* istanbul ignore next */
ZkDialog.install = function(Vue) {
  Vue.component(ZkDialog.name, ZkDialog)
}

export default ZkDialog



// WEBPACK FOOTER //
// ./src/packages/dialog/index.js